const PropertiesConstants = {
    PROPERTIES_ACTIVE_DEFAULT: true,
    PROPERTIES_INACTIVE_DEFAULT: true,
    PROPERTIES_SEARCHTEXT_DEFAULT: '',
    PROPERTIES_FEEDS_DEFAULT: true,
    PROPERTIES_MANUAL_DEFAULT: true,
    PROPERTIES_ASCENDING_DEFAULT: true,
    PROPERTIES_SORT_DEFAULT: 'created',
    PROPERTIES_SORT_LOCATION: 'location',
    PROPERTIES_SORT_TITLE: 'title',
    PROPERTIES_FEATURED_DEFAULT: 'all',
    PROPERTIES_FEATURED_PAID: 'paidOnly',
    PROPERTIES_FEATURED_UNPAID: 'unpaidOnly',
    PROPERTIES_START_KEY_EXCLUSIVE_DEFAULT: '',
    PROPERTIES_LIMIT_DEFAULT: 12,
    PROPERTIES_INCLUDE_DETAILS_DEFAULT: false,
    PROPERTIES_INCLUDE_RESTRICTIONS_DEFAULT: true,
    PROPERTIES_INCLUDE_MAINTENANCE_PARTNER_DEFAULT: true,
    PROPERTIES_INCLUDE_FEED_CLAIM_AND_CONVERT_UPDATE: true,
    PROPERTIES_UNVERIFIED_EMAIL_FEED_LIMIT: 5,
    PROPERTIES_INCLUDE_ARCHIVED: false,
    PROPERTIES_INCLUDE_UNARCHIVED: true,
    PROPERTIES_VIEW_TYPE: {
        GRID: 'grid',
        LIST: 'list',
    },
    PROPERTIES_SUBNAV_FILTER_TYPE: {
        ALL: 'all',
        ON_MARKET: 'on-market',
        OFF_MARKET: 'off-market',
    },
};

export default PropertiesConstants;
